import React from 'react'
// constants
import * as types from './actionTypes'
// services
import scheduleService from '../../services/ScheduleService'
import downloadService from '../../services/DownloadService'
// store
import { fetchDataByContext } from '../context/ContextActions'
import * as authSelectors from '../auth/authSelectors'
// utils
import { toRoute } from '../../utils/Router'
import { query2Object } from '../../utils/URLUtils'

export function requestEspecialidadesAll() {
  return {
    type: types.REQUEST_ESPECIALIDADES_ALL,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function receiveEspecialidadesAll({ data, error }) {
  return {
    type: types.RECEIVE_ESPECIALIDADES_ALL,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
  }
}

/**
 * Lista todas especialidades ou especialidades da clinica caso possua context.
 */
export function fetchEspecialidadesAll() {
  return async dispatch => {
    dispatch(requestEspecialidadesAll())
    try {
      const data = await scheduleService.listEspecialidadesAll()
      dispatch(receiveEspecialidadesAll({ data }))
    } catch (error) {
      console.error(error.message)
      dispatch(receiveEspecialidadesAll({ error: 'Erro ao consultar especialidades' }))
    }
  }
}

export function requestEspecialidades() {
  return {
    type: types.REQUEST_ESPECIALIDADES,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function receiveEspecialidades({ data, error }) {
  return {
    type: types.RECEIVE_ESPECIALIDADES,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
  }
}

/**
 * Lista todas especialidades ou especialidades da clinica caso possua context.
 */
export function fetchEspecialidades() {
  return async dispatch => {
    dispatch(requestEspecialidades())
    const query = query2Object(window.location.search)
    const context = query.context || ''
    try {
      const data = await scheduleService.listEspecialidades(context)
      dispatch(receiveEspecialidades({ data }))
    } catch (error) {
      console.error(error.message)
      dispatch(receiveEspecialidades({ error: 'Erro ao consultar informações' }))
    }
  }
}

export function requestEnderecos() {
  return {
    type: types.REQUEST_ENDERECOS,
    isLoading: true,
    receivedAt: null,
  }
}

export function receiveEnderecos({ data }) {
  return {
    type: types.RECEIVE_ENDERECOS,
    isLoading: false,
    receivedAt: Date.now(),
    data,
  }
}

/**
 * Lista todos endereços disponíveis.
 */
export function fetchEnderecos() {
  return async dispatch => {
    dispatch(requestEnderecos())
    try {
      const data = await scheduleService.listEnderecos()
      const arrData = []
      for (const key in data.data) {
        const item = data.data[key]
        arrData.push(item)
      }
      dispatch(receiveEnderecos({ data: arrData }))
    } catch (error) {
      dispatch(receiveEnderecos({ error: 'Erro ao consultar endereços' }))
    }
  }
}

export function requestSearch() {
  return {
    type: types.REQUEST_SEARCH,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function receiveSearch({ data, tipo, error }) {
  return {
    type: types.RECEIVE_SEARCH,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    tipo,
    error,
  }
}

/**
 * Lista médicos com base nos filtros de busca.
 */
export function fetchSearch(params = { page: 1, limit: 50 }) {
  return async dispatch => {
    dispatch(requestSearch())
    const query = query2Object(window.location.search)
    const context = query.context || ''
    try {
      const data = await scheduleService.search(context, params)
      console.log('RECEIVE')
      dispatch(receiveSearch({ data, tipo: 'teleconsulta' }))
      console.log('RECEIVE_DEPIOIS')
    } catch (error) {
      console.log('RECEIVE1')
      console.error(error.message)
      dispatch(receiveSearch({ error: 'Erro ao consultar informações' }))
    }
  }
}

/**
 * Lista médicos com base nos filtros de busca.
 */
export function fetchSearchPlantoes(params = { page: 1, limit: 50 }) {
  return async dispatch => {
    dispatch(requestSearch())
    const query = query2Object(window.location.search)
    const context = query.context || ''
    try {
      const data = await scheduleService.searchPlantoes(context, params)
      console.log('RECEIVE2')
      dispatch(receiveSearch({ data, tipo: 'plantao' }))
    } catch (error) {
      console.log('RECEIVE3')
      console.error(error.message)
      dispatch(receiveSearch({ error: 'Erro ao consultar informações' }))
    }
  }
}

export function requestMedico() {
  return {
    type: types.REQUEST_MEDICO,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function receiveMedico({ data, error }) {
  return {
    type: types.RECEIVE_MEDICO,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
  }
}

/**
 * Consulta médico.
 */
export function fetchMedico(id, callback = () => {}) {
  return async dispatch => {
    dispatch(requestMedico())
    const query = query2Object(window.location.search)
    const context = query.context || ''
    try {
      const data = await scheduleService.getMedico(id, context)
      dispatch(receiveMedico({ data }))
      callback(null, data)
    } catch (error) {
      console.error(error.message)
      dispatch(receiveMedico({ error: 'Erro ao consultar informações do médico' }))
      callback(error)
    }
  }
}

export function requestMedicoCalendar() {
  return {
    type: types.REQUEST_MEDICO_CALENDAR,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function receiveMedicoCalendar({ data, error }) {
  return {
    type: types.RECEIVE_MEDICO_CALENDAR,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
  }
}

/**
 * Consulta informações para montar clendário do médico.
 */
export function fetchMedicoCalendar(id, callback = () => {}) {
  return async dispatch => {
    dispatch(requestMedicoCalendar())
    try {
      const data = await scheduleService.getMedicoCalendar(id)
      dispatch(receiveMedicoCalendar({ data }))
      callback(null, data)
    } catch (error) {
      console.error(error.message)
      dispatch(receiveMedicoCalendar({ error: 'Erro ao consultar informações' }))
      callback(error)
    }
  }
}

export function requestMedicoRatings() {
  return {
    type: types.REQUEST_MEDICO_RATINGS,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function receiveMedicoRatings({ data, error }) {
  return {
    type: types.RECEIVE_MEDICO_RATINGS,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
  }
}

/**
 * Consulta avaliações do médico.
 */
export function fetchMedicoRatings(id, callback = () => {}) {
  return async dispatch => {
    dispatch(requestMedicoRatings())
    try {
      const data = await scheduleService.getMedicoRatings(id)
      dispatch(receiveMedicoRatings({ data }))
      callback(null, data)
    } catch (error) {
      console.error(error.message)
      dispatch(receiveMedicoRatings({ error: 'Erro ao consultar avaliações do profissional' }))
      callback(error)
    }
  }
}

export function resetMedico() {
  return {
    type: types.RESET_MEDICO,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function requestPlantao() {
  return {
    type: types.REQUEST_PLANTAO,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function requestRating() {
  return {
    type: types.REQUEST_RATING,
    isLoading: true,
    data: {},
  }
}

export function receiveRating(data) {
  return {
    type: types.RECEIVE_RATING,
    isLoading: false,
    data,
  }
}

/**
 * Obtem avaliação do médico e plataforma.
 */
export function fetchRating(contextRating, callback = () => {}) {
  return async dispatch => {
    dispatch(requestRating())
    try {
      const res = await scheduleService.getRating(contextRating)
      dispatch(receiveRating(res))
      callback(null, res)
    } catch (error) {
      console.error(error.message)
      dispatch(receiveRating({}))
      callback(error)
    }
  }
}

export function requestSaveRating() {
  return {
    type: types.REQUEST_SAVE_RATING,
    isLoading: true,
  }
}

export function receiveSaveRating() {
  return {
    type: types.RECEIVE_SAVE_RATING,
    isLoading: false,
  }
}

/**
 * Envia avaliação do médico e plataforma.
 */
export function saveRating(contextRating, data, callback = () => {}) {
  return async dispatch => {
    dispatch(requestSaveRating())
    try {
      const res = await scheduleService.postRating(contextRating, data)
      dispatch(receiveSaveRating())
      callback(null, res)
    } catch (error) {
      console.error(error.message)
      dispatch(receiveSaveRating({ error: 'Erro ao enviar avaliação' }))
      callback(error)
    }
  }
}

export function receivePlantao({ data, error }) {
  return {
    type: types.RECEIVE_PLANTAO,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
  }
}

/**
 * Consulta plantão.
 */
export function fetchPlantao(id) {
  return async dispatch => {
    dispatch(requestPlantao())
    try {
      const data = await scheduleService.getPlantao(id)
      dispatch(receivePlantao({ data }))
    } catch (error) {
      console.error(error.message)
      dispatch(receivePlantao({ error: 'Erro ao consultar informações do plantão' }))
    }
  }
}

export function requestPlantaoFila(silent) {
  return {
    type: types.REQUEST_PLANTAO_FILA,
    isLoading: silent ? false : true,
    receivedAt: null,
    error: null
  }
}

export function receivePlantaoFila({ data, error }) {
  return {
    type: types.RECEIVE_PLANTAO_FILA,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
  }
}

/**
 * Consulta plantão fila (atualiza status online automaticamente).
 */
export function fetchPlantaoFila(id, context, silent = false) {
  return async dispatch => {
    dispatch(requestPlantaoFila(silent))
    try {
      const data = await scheduleService.getPlantaoFila(id, context)
      dispatch(receivePlantaoFila({ data }))
    } catch (error) {
      console.error(error.message)
      dispatch(receivePlantaoFila({ error: 'Erro ao consultar informações do plantão' }))
    }
  }
}

export function requestPlantaoUnicoPrice() {
  return {
    type: types.REQUEST_PLANTAO_UNICO_PRICE,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function receivePlantaoUnicoPrice({ data, error }) {
  return {
    type: types.RECEIVE_PLANTAO_UNICO_PRICE,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
  }
}

/**
 * Consulta preço atual de plantão externo (Brasil Telemedicina) com base na hora atual.
 */
export function fetchPlantaoUnicoPrice() {
  return async dispatch => {
    dispatch(requestPlantaoUnicoPrice())
    try {
      const query = query2Object(window.location.search)
      const context = query.context || ''
      const data = await scheduleService.getPlantaoUnicoPrice(context)
      dispatch(receivePlantaoUnicoPrice({ data }))
    } catch (error) {
      console.error(error.message)
      dispatch(receivePlantaoUnicoPrice({ error: error.message || 'Erro ao consultar informações do plantão' }))
    }
  }
}

export function requestSavePlantaoUnico() {
  return {
    type: types.REQUEST_SAVE_PLANTAO_UNICO,
    isLoading: true,
  }
}

export function receiveSavePlantaoUnico() {
  return {
    type: types.RECEIVE_SAVE_PLANTAO_UNICO,
    isLoading: false,
  }
}

/**
 * Cria plantão externo (Brasil Telemedicina).
 */
export function savePlantaoUnico(data, callback = () => {}) {
  return async dispatch => {
    dispatch(requestSavePlantaoUnico())
    const query = query2Object(window.location.search)
    const context = query.context || ''
    try {
      const res = await scheduleService.postPlantaoUnico(data, context)
      dispatch(receiveSavePlantaoUnico())

      if (res.status_pagamento === 2) {
        toRoute('pagamento', {
          id_teleconsulta: res.idResult,
        })
      } else {
        toRoute('conclusao', {
          id_teleconsulta: res.idResult,
        })
      }
      callback(null, res)
    } catch (error) {
      console.error(error.message)
      dispatch(receiveSavePlantaoUnico({ error: 'Erro ao criar plantão' }))
      callback(error)
    }
  }
}

export function requestAtendimento(silent = false) {
  return {
    type: types.REQUEST_ATENDIMENTO,
    isLoading: silent ? false : true,
    silent,
    receivedAt: null,
    data: null,
    error: null
  }
}

export function receiveAtendimento({ data, error }) {
  return {
    type: types.RECEIVE_ATENDIMENTO,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
  }
}

/**
 * Consulta teleconsulta ou teleavaliação.
 *
 * @param {String} type teleconsulta ou teleavaliacao
 * @param {Nuber} id
 */
export function fetchAtendimento(id, idIsHash = false, context = null, silent = false, callback = () => {}) {
  return async dispatch => {
    dispatch(requestAtendimento(silent))
    try {
      const data = await scheduleService.getAtendimento(id, idIsHash, context)
      dispatch(receiveAtendimento({ data }))
      callback(null, data)
    } catch (error) {
      console.error(error.message)
      dispatch(receiveAtendimento({ error: 'Erro ao consultar informações do atendimento' }))
      callback(error)
    }
  }
}

export function requestCreateAtendimento() {
  return {
    type: types.REQUEST_CREATE_ATENDIMENTO,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function receiveCreateAtendimento({ error }) {
  return {
    type: types.RECEIVE_CREATE_ATENDIMENTO,
    isLoading: false,
    receivedAt: Date.now(),
    error,
  }
}

/**
 * Cria um novo atendimento teleconsulta ou teleavaliação.
 */
export function createAtendimento(idPaciente, body, gaClientId) {
  return async dispatch => {
    dispatch(requestCreateAtendimento())
    const query = query2Object(window.location.search)
    const context = query.context || ''
    try {
      const data = await scheduleService.postAtendimento(idPaciente, body, context, gaClientId)
      dispatch(receiveCreateAtendimento({}))
      // redireciona para pagamento ou conclusão
      if (data.id_status === 6) { // Aguardando confirmação do profissional
        toRoute('conclusao', {
          id_teleconsulta: data.idResult,
        })
      } else if (data.id_status_pagamento === 2) { // Aguardando pagamento
        toRoute('pagamento', {
          id_teleconsulta: data.idResult,
        })
      } else {
        toRoute('conclusao', {
          id_teleconsulta: data.idResult,
        })
      }
    } catch (error) {
      console.error(error)
      dispatch(receiveCreateAtendimento({ error: error.message }))
    }
  }
}

export function resetCreateAtendimento() {
  return { type: types.RESET_CREATE_ATENDIMENTO }
}

export function requestJoinQueue() {
  return {
    type: types.REQUEST_JOIN_QUEUE,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function receiveJoinQueue({ error }) {
  return {
    type: types.RECEIVE_JOIN_QUEUE,
    isLoading: false,
    receivedAt: Date.now(),
    error,
  }
}

/**
 * Entra na fila de atendimento do plantão de urgencia.
 */
export function joinQueue(idPlantao, context, body) {
  return async dispatch => {
    dispatch(requestJoinQueue())
    try {
      const data = await scheduleService.putJoinQueue(idPlantao, context, body)
      dispatch(receiveJoinQueue({}))
      // redireciona para pagamento ou conclusão
      toRoute('plantao/sala-espera', {
        id_plantao_fila: data.id,
      })
    } catch (error) {
      console.error(error)
      dispatch(receiveJoinQueue({ error: error.message }))
    }
  }
}

export function resetJoinQueue() {
  return { type: types.RESET_JOIN_QUEUE }
}

export function requestLeaveQueue() {
  return {
    type: types.REQUEST_LEAVE_QUEUE,
    isLoading: true,
    receivedAt: null,
    error: null
  }
}

export function receiveLeaveQueue({ error }) {
  return {
    type: types.RECEIVE_LEAVE_QUEUE,
    isLoading: false,
    receivedAt: Date.now(),
    error,
  }
}

/**
 * Paciente informa motivo para abando do atendimento de urgência.
 */
export function fetchLeaveQueue(id, context, body) {
  return async dispatch => {
    dispatch(requestLeaveQueue())
    try {
      await scheduleService.putPlantaoFilaCancel(id, context, body)
      dispatch(receiveLeaveQueue({}))
      toRoute('')
    } catch (error) {
      console.error(error.message)
      dispatch(receiveLeaveQueue({ error: 'Erro ao informar abandono do atendimento' }))
    }
  }
}

export function resetLeaveQueue() {
  return { type: types.RESET_LEAVE_QUEUE }
}

export function requestReschedule() {
  return {
    type: types.REQUEST_RESCHEDULE,
    isLoading: true,
    error: null,
    success: null,
  }
}

export function receiveReschedule({ error, success }) {
  return {
    type: types.RECEIVE_RESCHEDULE,
    isLoading: false,
    error,
    success,
  }
}

/**
 * Reagenda (tele)consulta ou telemonitoramento.
 *
 * @param {Object} item { tipo: 'medico', id: 1, agendamento: '2020-03-30T14:15:00' }
 * @param {Function} callback
 */
export function fetchReschedule(data, context = null) {
  console.log('fetchReschedule')
  return async dispatch => {
    dispatch(requestReschedule())
    try {
      await scheduleService.putAtendimentoReschedule(data, context)
      dispatch(receiveReschedule({ success: 'Atendimento reagendado com sucesso.'}))
    } catch (error) {
      console.error(error)
      // dispatch(receiveReschedule({ error: 'Erro ao reagendar atendimento' }))
      dispatch(receiveReschedule({ error: error.message }))
    }
  }
}

export function resetReschedule() {
  return { type: types.RESET_RESCHEDULE }
}

export function requestScheduleReturn() {
  return {
    type: types.REQUEST_SCHEDULE_RETURN,
    isLoading: true,
    receivedAt: null,
    error: null,
    success: null,
  }
}

export function receiveScheduleReturn({ error, success }) {
  return {
    type: types.RECEIVE_SCHEDULE_RETURN,
    isLoading: false,
    error,
    success,
  }
}

/**
 * Solicita agendamento de retorno de teleconsulta / consulta.
 *
 * @param {Object} data { tipo: 'medico', id: 1, agendamento: '2020-03-30T14:15:00' }
 * @param {Function} callback
 */
export function fetchScheduleReturn(data) {
  return async dispatch => {
    dispatch(requestScheduleReturn())
    try {
      await scheduleService.putAtendimentoReturn(data)
      dispatch(receiveScheduleReturn({ success: 'Retorno agendado com sucesso.'}))
    } catch (error) {
      console.error(error)
      dispatch(receiveScheduleReturn({ error: error.message }))
      window.scrollTo(0, 0)
    }
  }
}

export function resetScheduleReturn() {
  return { type: types.RESET_SCHEDULE_RETURN }
}

export function fetchCallLink(id, callback) {
  return async dispatch => {
    dispatch(requestMedico())
    try {
      const data = await scheduleService.getCallLink(id)
      callback(null, data.link)
    } catch (error) {
      console.error(error.message)
      callback(error)
    }
  }
}

export function requestScheduleCancel() {
  return {
    type: types.REQUEST_SCHEDULE_CANCEL,
    isLoading: true,
    error: null,
    success: null
  }
}

export function receiveScheduleCancel({ error, success }) {
  return {
    type: types.RECEIVE_SCHEDULE_CANCEL,
    isLoading: false,
    error,
    success,
  }
}

/**
 * Cancela agendamento de teleconsulta ou telemonitoramento.
 *
 * @param {Object} data { tipo: 'medico', id: 1, motivo_cancelamento: '...' }
 */
export function fetchScheduleCancel(data) {
  return async dispatch => {
    dispatch(requestScheduleCancel())
    try {
      await scheduleService.putAtendimentoCancel(data)
      dispatch(receiveScheduleCancel({ success: 'Atendimento cancelado com sucesso.'}))
    } catch (error) {
      console.error(error)
      dispatch(receiveScheduleCancel({ error: error.message }))
      window.scrollTo(0, 0)
    }
  }
}

export function resetScheduleCancel() {
  return { type: types.RESET_SCHEDULE_CANCEL }
}

export function requestMedialRecords() {
  return {
    type: types.REQUEST_MEDICAL_RECORDS,
    isLoading: true,
    receivedAt: null,
    data: null,
    error: null
  }
}

export function receiveMedialRecords({ data, error }) {
  return {
    type: types.RECEIVE_MEDICAL_RECORDS,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
  }
}

/**
 * Consulta informações de prontuários médicos de atendimentos doo paciente.
 */
export function fetchMedialRecords() {
  return async dispatch => {
    dispatch(requestMedialRecords())
    try {
      const data = await scheduleService.getMedicalRecords()
      dispatch(receiveMedialRecords({ data }))
    } catch (error) {
      console.error(error.message)
      dispatch(receiveMedialRecords({ error: 'Erro ao consultar documentos' }))
    }
  }
}

export function resetMedialRecords() {
  return { type: types.RESET_MEDICAL_RECORDS }
}

export function fetchPrintMedicalDocument(type, instance, guiaUnimed = false, memed = false) {
  return async (dispatch, getState) => {
    // se tem arquivo no GCS
    // -------------------------------------------------------------------------
    if (instance.arquivo) {
      const arquivo = instance.arquivo
      let entity = arquivo.entity
      let gcsPath = arquivo.gcs_path
      const gcsPathBase64 = btoa(gcsPath)
      const url = await downloadService.getDownloadUrl(gcsPathBase64, entity)
      if (!url) {
        window.flash(<>Erro ao obter arquivo. Contate o suporte!</>, 'danger')
        return
      }
      var win = window.open(url, '_blank')
      win.focus()
      return
    }
    // Gera PDF dinamicamente (legado)
    // -------------------------------------------------------------------------
    const id = instance.id
    const state = getState()
    const jwt = authSelectors.jwt(state)
    let url = `${process.env.REACT_APP_API_MAIN}/prontuario/documento/${type}/${id}/pdf?jwt=${jwt}`
    if (guiaUnimed) url += '&unimed=true'
    if (memed) url += '&memed=true'
    var win = window.open(url, '_blank')
    win.focus()
  }
}

export function fetchPrintMedicalDocumentByProtocol(protocol, password) {
  return dispatch => {
    let url = `${process.env.REACT_APP_API_MAIN}/prontuario/documento-by-protocol/${protocol}/${password}/pdf`
    window.open(url, '_blank')
  }
}

export function requestInvoiceRequest() {
  return {
    type: types.REQUEST_INVOICE_REQUEST,
    isLoading: true,
  }
}

export function receiveInvoiceRequest() {
  return {
    type: types.RECEIVE_INVOICE_REQUEST,
    isLoading: false,
  }
}

export function fetchInvoiceRequest(idTeleconsulta) {
  return async dispatch => {
    dispatch(requestInvoiceRequest())
    try {
      await scheduleService.putInvoiceRequest(idTeleconsulta)
      dispatch(receiveInvoiceRequest())
      dispatch(fetchDataByContext())
      window.flash(<>Nota solicitada!<br /> Você será notificado quando o profissional enviar.</>, 'success')

    } catch (error) {
      console.error(error.message)
      dispatch(receiveInvoiceRequest())
      window.flash(<>Erro ao solicitar nota!<br />{error.message}</>, 'danger')
    }
  }
}

export function requestConfirmPresence() {
  return {
    type: types.REQUEST_CONFIRM_PRESENCE,
    isLoading: true,
  }
}

export function receiveConfirmPresence() {
  return {
    type: types.RECEIVE_CONFIRM_PRESENCE,
    isLoading: false,
  }
}

export function fetchConfirmPresence(idTeleconsulta) {
  return async dispatch => {
    dispatch(requestConfirmPresence())
    try {
      await scheduleService.postConfirmPresence(idTeleconsulta)
      dispatch(receiveConfirmPresence())
      dispatch(fetchDataByContext())
      window.flash(<>Presença confirmada.</>, 'success')

    } catch (error) {
      console.error(error.message)
      dispatch(receiveConfirmPresence())
      window.flash(<>Erro ao confirmar presença!<br />{error.message}</>, 'danger')
    }
  }
}

export function fetchPrintInvoice(file) {
  return async (dispatch, getState) => {
    const jwt = authSelectors.jwt(getState())
    let url = `${process.env.REACT_APP_API_MAIN}/cdn/medico_nfs_paciente/${file}?jwt=${jwt}`
    var win = window.open(url, '_blank')
    win.focus()
  }
}

export function requestAllCabins() {
  return {
    type: types.REQUEST_ALL_CABINS,
    isLoading: true,
    receivedAt: null,
    data: null,
    error: null
  }
}

export function receiveAllCabins({ data, error }) {
  return {
    type: types.RECEIVE_ALL_CABINS,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
  }
}

export function fetchAllCabins() {
  return async dispatch => {
    dispatch(requestAllCabins())
    const query = query2Object(window.location.search)
    const context = query.context || ''
    try {
      const data = await scheduleService.getCabins(context)
      dispatch(receiveAllCabins({ data }))

    } catch (error) {
      console.error(error.message)
      dispatch(receiveAllCabins({ error: error.message }))
    }
  }
}

export function requestCabin(silent) {
  return {
    type: types.REQUEST_CABIN,
    isLoading: silent ? false : true,
    receivedAt: null,
    data: null,
    error: null
  }
}

export function receiveCabin({ data, error }) {
  return {
    type: types.RECEIVE_CABIN,
    isLoading: false,
    receivedAt: Date.now(),
    data,
    error,
  }
}

export function fetchCabin(id, silent) {
  return async dispatch => {
    dispatch(requestCabin(silent))
    const query = query2Object(window.location.search)
    const context = query.context || ''
    try {
      const data = await scheduleService.getCabin(id, context)
      dispatch(receiveCabin({ data }))

    } catch (error) {
      console.error(error.message)
      dispatch(receiveCabin({ error: error.message }))
    }
  }
}
